import { render } from "./jobs-dashboard.vue?vue&type=template&id=04995674"
import script from "./jobs-dashboard.vue?vue&type=script&lang=js"
export * from "./jobs-dashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__